import {Brick} from './brick/brick';
import {Snake} from './snake/snake';
import {Bit} from './bit/bit';
import {Board} from './board/board';
import {Food} from './food/food';

export class Serializer {
  static board2json(board: Board, snakeMap: { [p: string]: Snake }): any {
    return {
      rows: board.rows,
      cols: board.cols,
      delay: board.delay,
      food: this.foods2json(board.food),
      walls: Serializer.walls2json(board.walls),
      snakes: Serializer.snakes2json(snakeMap)
    };
  }

  static brick2json(brick: Brick): any {
    return {type: brick.type, color: brick.color, port: brick.port };
  }
  static walls2json(walls: Brick[][]): any {
    return walls.map(row => row.map( brick => Serializer.brick2json(brick)));
  }
  static snakes2json(snakeMap: { [p: string]: Snake }): any {
    const res = {};
    for (const entry of Object.entries(snakeMap)) {
      res[entry[0]] = this.snake2json(entry[1]);
    }
    return res;
  }
  static bit2json(bit: Bit): any {
    return {x: bit.x, y: bit.y, type: bit.type};
  }
  static snake2json(snake: Snake): any {
      return {
        bits: snake.bits.map(Serializer.bit2json),
        direction: snake.direction,
        grow: snake.grow,
        colorScheme: snake.colorScheme,
        score: snake.score,
        ate: snake.ate,
        lives: snake.lives,
        mX: snake.mX,
        mY: snake.mY,
      };
  }
  static json2board(board: Board, data: any, userName: string): { [p: string]: Snake } {
    board.cols = data.cols;
    board.rows = data.rows;
    board.delay = data.delay;
    board.food = data.food.map(Serializer.json2food);
    board.newWalls();
    Serializer.json2walls(board.walls, data.walls);
    return Serializer.json2snakes(board.snakes, data.snakes, userName);
  }

  private static json2walls(walls: Brick[][], data: any): any {
    for (let y = 0; y < walls.length; y ++) {
      const row = walls[y];
      const drow = data[y];
      for (let x = 0; x < row.length; x ++) {
        Serializer.json2brick(row[x], drow[x]);
      }
    }
  }

  private static json2brick(brick: Brick, data: any): void {
    Object.assign(brick, data);
    brick.empty = brick.type === 'empty';
  }

  private static json2snakes(snakes: Snake[], data: any, me: string): { [p: string]: Snake } {
    const snakeMap = {};
    snakes.length = 0;
    snakes.push(Serializer.json2snake(data[me], me));
    snakeMap[me] = snakes[0];
    for (const entry of Object.entries(data)) {
      if (entry[0] === me) { continue; }
      const snake = Serializer.json2snake(entry[1], entry[0]);
      snakes.push(snake);
      snakeMap[entry[0]] = snake;
    }
    return snakeMap;
  }

  static json2snake(data: any, tt?: string): Snake {
    const snake = new Snake(data.bits[1].x, data.bits[1].y, data.direction);
    snake.bits = data.bits.map(b => Serializer.json2bit(b, tt));
    delete data.bits;
    delete data.direction;
    snake.grow = data.grow;
    delete data.grow;
    Object.assign(snake, data);
    return snake;
  }

  static json2bit(data: any, tt: string): Bit {
    const res = new Bit(data.x, data.y);
    res.tooltip = tt;
    res.type = data.type;
    return res;
  }

  static food2json(food: Food): any {
    return food;
  }

  static foods2json(food: Food[]): any {
    return food.map(this.food2json);
  }

  static json2food(data: any): Food {
    const res = new Food(0, 0, 'normal');
    return Object.assign(res, data);
  }
}
